module.exports = __webpack_public_path__ + "static/media/LogoDE.6ad58477.svg";